import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveFileUrl as fileUrl } from "@/libs/fileUrl";
export default {
  props: {
    type: Number,
    item: Object,
    clickMode: {
      type: String,
      default: 'link'
    }
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    fileUrl: fileUrl,
    lookDetails: function lookDetails(e) {
      if (this.clickMode === 'course') {
        window.open(e.link, '_blank');
      } else if (this.type === 1) {
        this.$router.push({
          path: '/professionalTeachingCourse',
          query: {
            libraryId: e.id
          }
        });
      } else {
        window.open(e.link);
      }
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["special_click", "CLK", {
          //以下为事件属性
          cate_special_name: "专业资源库",
          // 轮播图名称
          special_name: "".concat(e.name)
        }]
      });
      //   aplus_queue.push({
      //   action: "aplus.record",
      //   arguments: [
      //     "course_click",
      //     "CLK",
      //     {
      //       //以下为事件属性
      //       course_name: e.courseName || e.name, // 课程名称
      //       course_id: e.newId?e.newId:e.id, //课程id
      //       college_name: e.fkCourseEmceeSchool || e.emceeCompanyname, // 所属学校
      //       major_name: e.fkCourseMajor || e.majorId, // 所属专业
      //     },
      //   ],
      // });
    }
  }
};